const FALLBACK_GROUP_CLAIM_PATHS = ['groups', 'http://wso2.org/claims/groups'];

function readClaimPath(source, path) {
    if (!source || !path) return undefined;
    if (Object.prototype.hasOwnProperty.call(source, path)) return source[path];

    return path.split('.').reduce((value, key) => {
        if (!value || typeof value !== 'object') return undefined;
        return value[key];
    }, source);
}

function normalizeClaimValues(value) {
    if (!value) return [];
    if (Array.isArray(value)) {
        return value.flatMap((item) => normalizeClaimValues(item));
    }
    if (typeof value === 'object') {
        return Object.values(value).flatMap((item) => normalizeClaimValues(item));
    }
    return String(value)
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
}

export function getGroupValues({ groupsClaimPath, idTokenClaims, user }) {
    const paths = [groupsClaimPath, ...FALLBACK_GROUP_CLAIM_PATHS].filter(Boolean);
    const values = new Set();

    [idTokenClaims, user].forEach((source) => {
        paths.forEach((path) => {
            normalizeClaimValues(readClaimPath(source, path)).forEach((group) => values.add(group));
        });
    });

    return Array.from(values);
}

export function hasAllowedGroup({ allowedGroups, groups }) {
    const allowed = new Set((allowedGroups || []).map((group) => group.toLowerCase()));
    return (groups || []).some((group) => allowed.has(String(group).toLowerCase()));
}
